import { render, staticRenderFns } from "./ProgramModuleActivityListFilter.vue?vue&type=template&id=affb13fe&scoped=true"
import script from "./ProgramModuleActivityListFilter.vue?vue&type=script&lang=js"
export * from "./ProgramModuleActivityListFilter.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleActivityListFilter.vue?vue&type=style&index=0&id=affb13fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb13fe",
  null
  
)

export default component.exports